module.exports = __webpack_public_path__ + "img/view.4ddf583b.svg";